<ng-container
  *ngIf="props$ | async as props"
  [class.d-none]="isLoading$ | async"
  [ngSwitch]="nodeType$ | async"
>
  <flo-event-filter-list
    *ngSwitchCase="'event'"
    [props]="props"
  ></flo-event-filter-list>
  <flo-video-list *ngSwitchCase="'video'" [props]="props"> </flo-video-list>
  <ng-container *ngSwitchCase="'experience-grappling'">
    <div *ngIf="searchFilters$ | async as searchFilters" class="filters-wrap mx-n3 mx-md-n5 px-md-3">
      <h2 *ngIf="searchFilters.resultsHeader" class="h5 px-3 mx-md-n3 px-md-5" [textContent]="searchFilters.resultsHeader"></h2>
      <flo-search-filters
        [searchModel]="searchFilters.search"
        [filters]="searchFilters.filters"
      ></flo-search-filters>
    </div>
    <ng-container *ngIf="isFilterOrSearchLoading$ | async; else resultsSection">
      <div data-test="athlete-results-spinner" class="d-flex spinner-container"><div class="spinner-border text-light d-flex m-auto"></div></div>
    </ng-container>
    <ng-template #resultsSection>
      <ng-container *ngFor="let section of props.results; trackBy: trackById">
        <ng-container [ngSwitch]="section.type">
          <ng-container *ngSwitchCase="'collection'">
            <div *ngIf="section.id !== 'search' && section.id !=='filters'" class="table-container">
              <flo-section-table [section]="section"></flo-section-table>
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'message'">
            <flo-message [message]="section">
            </flo-message>
          </ng-container>
        </ng-container>
      </ng-container>
    </ng-template>
  </ng-container>
  <flo-node-type-list *ngSwitchDefault [props]="props"></flo-node-type-list>
</ng-container>
<div
  *ngIf="shouldShowPaginationButton$ | async"
  class="d-flex justify-content-center mb-5"
  [class.d-none]="isLoading$ | async"
>
  <button
    data-test="see-more-btn"
    floAnalytics
    name="See More"
    (click)="selectMoreNodes()"
    class="btn btn-primary font-family-regular"
    >See More</button
  >
</div>
